import keyMirror from 'keymirror';

export default keyMirror({
  CREATE_BOOKMARK_START   : null,
  CREATE_BOOKMARK_SUCCESS : null,
  CREATE_BOOKMARK_FAILURE : null,
  LIST_BOOKMARKS_START    : null,
  LIST_BOOKMARKS_SUCCESS  : null,
  LIST_BOOKMARKS_FAILURE  : null,
  DELETE_BOOKMARK_START   : null,
  DELETE_BOOKMARK_SUCCESS : null,
  DELETE_BOOKMARK_FAILURE : null
});



// WEBPACK FOOTER //
// banquet/constants/BookmarkConstants.js